import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter as Router } from 'react-router-dom';
import Routing from './routing/routing';
import { GlobalStyle } from './styles/GlobalStyles';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1, 
    },
  },
});

function App() {
	return (
		<QueryClientProvider client={queryClient}>
		<Router>
			<GlobalStyle />
			<Routing />
		</Router>
		</QueryClientProvider>
	)
}

export default App
